import '.j{display:flex;}.ssr-plugin'
import '.k{justify-content:center;}.ssr-plugin'
import '.v{flex-direction:column;}.ssr-plugin'
import '.r{align-items:center;}.ssr-plugin'
import '.b1{gap:0.5rem;}.ssr-plugin'
import '.b6{cursor:pointer;}.ssr-plugin'
import '.if{padding:0.75rem;}.ssr-plugin'
import '.ag{border-radius:1.25rem;}.ssr-plugin'
import '.ay{border:var(--blue-border);}.ssr-plugin'
import '.ah{background-color:var(--shades-white);}.ssr-plugin'
import '.e5{transition:background-color 0.2s ease;}.ssr-plugin'
import '.ff{width:2.5rem;}.ssr-plugin'
import '.eu{height:2.5rem;}.ssr-plugin'
import '.ig{color:var(--shades-blue-700);}.ssr-plugin'
import '.ih{font-size:0.9rem;}.ssr-plugin'
import '.bd{font-weight:400;}.ssr-plugin'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { styled } from 'inlines'
import { IconProp } from '@fortawesome/fontawesome-svg-core'
import { MouseEventHandler } from 'react'

export type SocialMediaButtonProps = {
  icon: IconProp
  label: string
  onClick: MouseEventHandler<HTMLButtonElement>
  isMobile?: boolean
}

export const SocialMediaButton = ({
  icon,
  label,
  onClick,
  isMobile,
}: SocialMediaButtonProps) => {
    return (
      <styled.button className="j k v r b1 b6 if ag ay ah e5"
        style={{
          '&:hover': {
            backgroundColor: 'var(--shades-blue-50)',
          },
          width: isMobile ? '8rem' : '5.5rem',
          height: isMobile ? '8rem' : '5.5rem',
        }}
        onClick={onClick}
      >
        <div className="ff eu j r k ig"
          style={{
            fontSize: isMobile ? '3rem' : '2rem',
          }}
        >
          <FontAwesomeIcon icon={icon} />
        </div>
        <span className="ih ig bd"
        >
          {label}
        </span>
      </styled.button>
    )
}